import moment from 'moment'
require('moment/locale/en-ca')

export const parseToDateTimeObject = (dateTimeString, locale = 'en') => {
  return moment(dateTimeString).locale(locale)
}
export const formatDate = (dateTimeString, locale = 'en-US', month = 'long') =>
  dateTimeString
    ? Intl.DateTimeFormat(locale, {
        month: month,
        day: '2-digit',
        year: 'numeric'
      }).format(Date.parse(dateTimeString))
    : ''

export const formatDateShort = (dateTimeString, locale = 'en-US') =>
  dateTimeString
    ? Intl.DateTimeFormat(locale, {
        month: 'short',
        day: '2-digit'
      }).format(Date.parse(dateTimeString))
    : ''

export const formatDateTime = (dateTimeString, locale = 'en') => {
  moment.locale(locale)
  return moment(dateTimeString).format('MMMM Do, YYYY h:mm A')
}

export const formatTime = (dateTimeString, locale = 'en') => {
  moment.locale(locale)
  return moment(dateTimeString).format('h:mm A')
}

export const formatDayMonthDay = (dateTimeString, locale = 'en') => {
  const momentDate = moment(dateTimeString)
  momentDate.locale(locale)
  return momentDate.format('dddd, MMMM Do, YYYY')
}

export const formatDayMonth = (dateTimeString, locale = 'en') => {
  const momentDate = moment(dateTimeString)
  momentDate.locale(locale)
  return momentDate.format('MMMM Do')
}

export const convertSecsToMins = seconds => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  let result = ''
  if (mins > 0) {
    result += `${mins}m`
  }
  if (secs > 0) {
    result += ` ${secs}s`
  }
  return result
}

export const formatDifference = (start, end) => {
  const diff = moment.duration(moment(end).diff(moment(start)))
  return `${diff.days() * 24 + diff.hours()}h ${diff.minutes()}m`
}

export const getCurrentGreetings = () => {
  const currentHour = moment().hour()
  let newGreeting = ''
  if (currentHour < 12) {
    newGreeting = 'goodMorning'
  } else if (currentHour < 18) {
    newGreeting = 'goodAfternoon'
  } else {
    newGreeting = 'goodEvening'
  }
  return `fullReport.${newGreeting}`
}

const getBoldText = (text, addBold) => {
  if (addBold) {
    return `<strong>${text}</strong>`
  }
  return text
}

export const formatSeconds = (seconds, format, addBold = false) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')
  const formattedSeconds = secs.toString().padStart(2, '0')

  switch (format) {
    case 'hh:mm':
      return `${formattedHours}:${formattedMinutes}`
    case 'mm:ss':
      return `${formattedMinutes}:${formattedSeconds}`
    case 'min':
      return `${Math.floor(seconds / 60)} min`
    default:
      return hours > 0
        ? `${getBoldText(hours, addBold)} hr ${getBoldText(minutes, addBold)} min`
        : `${getBoldText(minutes, addBold)} min`
  }
}
